import { isEmpty } from "lodash";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import CustomText from "pages/_components/CustomText/CustomText";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { actions as contactActions } from "reducers/contactDestination";
import * as i18n from "util/i18n";
import ContactSummaryBody from "./_components/ContactSummary";

const ModifySummaryPage = () => {
    const { frequentDestinationModify } = useSelector((state) => state.contactDestination);
    const { contactTicket } = useSelector((state) => state.contactDestination);
    const { dispatch } = useConfirmTransaction(frequentDestinationModify, contactTicket, "contactDestination");
    const { id } = useParams();

    useEffect(() => {
        if (isEmpty(frequentDestinationModify)) {
            dispatch(contactActions.modifyFrequentDestinationPreviewRequest(id));
        }
    }, []);

    return (
        <>
            <Notification scopeToShow="frequentDestinationModifyConfirm" />
            <ResponsiveHeader id="frequentDestination.modify.tittle" />
            <MainContainer showLoader={false}>
                <CustomText text={i18n.get("frequentDestination.modify.subtitle")} />
                <ContactSummaryBody
                    accountNumber={frequentDestinationModify.accountNumber}
                    productType={frequentDestinationModify?.productType}
                    cbu={frequentDestinationModify.cbu}
                    name={frequentDestinationModify.name}
                    localBank={frequentDestinationModify.localBank}
                    recipientEmail={frequentDestinationModify.recipientEmail}
                    recipientDocumentType={frequentDestinationModify.recipientDocumentType}
                    recipientDocumentNumber={frequentDestinationModify.recipientDocumentNumber}
                    recipientName={frequentDestinationModify.recipientName}
                />
                <GeneralCredentialForm
                    transactionData={frequentDestinationModify}
                    action={contactActions.modifyFrequentDestinationRequest}
                    idActivity="destinations.modify"
                    hideIndications
                />
            </MainContainer>
        </>
    );
};

export default ModifySummaryPage;
